export default __webpack_public_path__ + "6f9105bda19b7490c6d4350ec95c7218.png";